import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useApplications} from '../hooks/useApplications.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useApplications();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
